export default "__VITE_ASSET__T4Qn0ZMy__"